import { render, staticRenderFns } from "./delays-and-response-time-dossier.vue?vue&type=template&id=28b0bd3c&"
import script from "./delays-and-response-time-dossier.ts?vue&type=script&lang=ts&"
export * from "./delays-and-response-time-dossier.ts?vue&type=script&lang=ts&"
import style0 from "../../shared/styles/statistical-analysis-dossier.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./delays-and-response-time-dossier.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports